<template>
  
  <div class="modal__overlay">

      <div class="modal-activity" ref="modalRef">
          <i @click="close()" style="position: absolute; right: 36px; cursor: pointer;" class="material-icons">close</i>
          <div style="display: flex; align-items: center; gap: 24px;">
            <h4>{{ content.id ? $t('commentsWall.EDIT_EXCHANGE_ACTIVITY') : $t('commentsWall.CREATE_EXCHANGE_ACTIVITY') }}</h4>
            <span style="font-size: 16px; color: #bdbdbd;">{{ $t('commentsWall.STEP_OF', { step: step, total: 2 }) }}</span>
          </div>

          <div style="display: flex; flex-direction: column; gap: 22px;" v-show="step == 1">

            <div class="select-step">
              <span :class="{ '--selected': stepSelected == 'course' }" @click="stepSelected = 'course'">{{ $t('commentsWall.COURSE_SCREEN') }}</span>
              <span :class="{ '--selected': stepSelected == 'board' }" @click="stepSelected = 'board'">
                {{ content.type.toUpperCase() === 'FORUM' ? $t('commentsWall.FORUM_SCREEN') : $t('commentsWall.ACTIVITY_SCREEN') }}
              </span>
            </div>

          
            <div v-show="stepSelected == 'course'" class="content-container">
              <h4>{{ $t('commentsWall.STATEMENT') }}</h4>
              <div>
                    <TinyMCE 
                        :content="courseView.enunciado"
                        ref="tinyEditorPreview"
                        :id="'activity-courseView'"
                    />
                </div>

                <div class="pedagogical">
                  <h4>{{ $t('commentsWall.PEDAGOGICAL_CONTENT') }}</h4>
                  <div :class="{ active: courseView.configPedagogical.show }" class="toggle-button" @click="courseView.configPedagogical.show = !courseView.configPedagogical.show">
                        <div class="toggle-handle"></div>
                    </div>
                </div>

                <div style="width: 100%;" class="select">
                  <template v-if="courseView.configPedagogical.show">
                    <Input 
                      type="text" 
                      id="geniallyURL" 
                      :placeholder="$t('commentsWall.LINK')" 
                      v-model="courseView.geniallyURL" 
                      :label="$t('commentsWall.LINK')" 
                      :supportText="$t('commentsWall.LINK_SUPPORT_TEXT')" 
                    />

                  </template>
                </div>
            </div>

            <div v-show="stepSelected == 'board'" class="content-container">
                <div class="pedagogical">
                    <h4>CONTENIDO PEDAGÓGICO</h4>
                    <div :class="{ active: boardView.configPedagogical.show }" class="toggle-button" @click="boardView.configPedagogical.show = !boardView.configPedagogical.show">
                        <div class="toggle-handle"></div>
                    </div>
                </div>

                <template v-if="boardView.configPedagogical.show">
                    <Input type="text" id="geniallyURL" :placeholder="'Link'" v-model="boardView.geniallyURL" label="Link" />
                </template>

                <h4>{{ $t('commentsWall.INSTRUCTION') }}</h4>
                <div>
                    <TinyMCE 
                        :content="boardView.consigna"
                        ref="tinyEditorActivityView"
                        :id="'activity-preview'"
                    />
                </div>
            </div>
          </div>

          <div style="display: flex; flex-direction: column; gap: 22px;" v-show="step == 2">
            <div class="pedagogical">
              <h4>{{ $t('commentsWall.MARK_AS_MANDATORY_ACTIVITY') }}</h4>
              <div 
                    :class="{ active: step2view.isMandatory }" 
                    class="toggle-button" 
                    @click="toggleMandatory"
                    :style="{ opacity: status === 'A1' ? 0.5 : 1, cursor: status === 'A1' ? 'not-allowed' : 'pointer' }"
                >
                    <div class="toggle-handle"></div>
                </div>
            </div>

            
            <div class="config-title-edit">
              <h4>{{ $t('commentsWall.EXCHANGE_SPACE_CONFIGURATION') }}</h4>
              <button 
                  @click.stop="enableEditing()"
                  v-if="status === 'A1'"
                  class="edit-button"
                  :class="{ 'editing': editing }"
                >
                  <i class="material-icons">edit</i>
                  {{ $t('global.EDIT') }}
                </button>
            </div>


            <Select 
                :label="$t('commentsWall.NUMBER_OF_TOPICS')"
                :values="temas"
                valueLabel="label"
                valueProp="value"
                id="themesQty"
                v-model="themesQty"
                :disabled="status === 'A1'"
                :style="{ opacity: status === 'A1' ? 0.5 : 1, cursor: status === 'A1' ? 'not-allowed' : 'pointer', PointerEvents: status === 'A1' ? 'none' : 'auto', }"
                :class="{ 'disabled': status === 'A1' }"
            />

            <div class="themes">  
                <div class="theme" v-for="(theme, index) in step2view.commentsWallHeaders" :key="index">
                    <span>{{ index + 1 }}.</span>
                    <input
                        v-model="step2view.commentsWallHeaders[index]" 
                        :disabled="status === 'A1' && !editing"
                        :style="{ opacity: status === 'A1' && !editing ? 0.5 : 1, cursor: status === 'A1' && !editing ? 'not-allowed' : 'pointer' }"
                    />
                </div>
            </div>
          </div>

          <div class="modal__buttons" >
            <button class="cancel" @click.stop="close()">Cancelar</button>
            <button class="confirm" 
                @click="next()"
                :disabled="saving ||
                  (stepSelected === 'course' && courseView.configPedagogical.show && v$.courseView.$invalid) || 
                  (stepSelected === 'board' && boardView.configPedagogical.show && v$.boardView.$invalid)
                  "
            >
            {{ step == 1 ? $t('global.CONTINUE') : $t('global.SAVE') }}
            <i class="material-icons">arrow_forward</i>
            </button>
          </div>

      </div>


  </div>
</template>

<script >
import { ref, watch } from 'vue';
import Input from '../../../components/Input.vue';
import Select from '../../../components/Inputs/Select.vue';
import TinyMCE from '@/components/TinyMCE.vue';
import defaultContents from "./defaultContents.js";
import { required, url } from '@vuelidate/validators';
import { useStore } from 'vuex';
import useVuelidate from '@vuelidate/core';
import { useI18n } from 'vue-i18n';


export default {
props: ['content', 'status'],
components: {
  Input,
  TinyMCE,
  Select
},
emits: ['close', 'reload'],
setup(props, { emit }) {
  const { t } = useI18n();
  const enunciadoTemplate = defaultContents.find(cont => cont.id == props.content.type)?.content;
  const consignaTemplate = defaultContents.find(cont => cont.id == 'COMMENTSWALL-CONSIGNA')?.content;
  const stepSelected = ref('course');
  const step = ref(1)
  const step2view = ref({
    isMandatory: props.content.isMandatory,
    commentsWallHeaders: props.content.commentsWallHeaders ? props.content.commentsWallHeaders : ['Tema 1'],
    commentsWallHeadersBackup: []
  })
  const themesQty = ref(step2view.value.commentsWallHeaders.length || 1)
  const tinyEditorPreview = ref(null);
  const tinyEditorActivityView = ref(null);
  const store = useStore()
  const saving = ref(false)
  const v$ = useVuelidate();
  const editing = ref(false);


  watch(themesQty, () => {
    let newArray = []
    for (let x = 0; x < themesQty.value; x++){
      newArray.push(step2view.value.commentsWallHeaders[x] ||  `Tema ${x+1}`)
    }
    step2view.value.commentsWallHeaders = newArray
  })

  const obtainGeniallyURL = (html) => {
    if (!html) return ''
    let $div = document.createElement('div');
    $div.innerHTML = html;
    let $iframe = $div.querySelector('iframe');
    let $src = $iframe.getAttribute('src');
    $div.remove();
    return $src;
  }
  const temas = [
    {
      value: 1,
      label: '1 Tema'
    },
    {
      value: 2,
      label: '2 Temas'
    },
    {
      value: 3,
      label: '3 Temas'
    },
    {
      value: 4,
      label: '4 Temas'
    },
    {
      value: 5,
      label: '5 Temas'
    },
    {
      value: 6,
      label: '6 Temas'
    },
    {
      value: 7,
      label: '7 Temas'
    },
    {
      value: 8,
      label: '8 Temas'
    },
    {
      value: 9,
      label: '9 Temas'
    },
    {
      value: 10,
      label: '10 Temas'
    },
  ]

  const close = () => emit('close')

  const obtainContent = (tag, text) => {
    let open = `[BEGIN_${tag}]`;
    let close = `[END_${tag}]`;
    let begin = text.indexOf(open) + open.length;
    let end = text.indexOf(close);

    if (begin !== -1 && end !== -1) {
      return text.substring(begin, end);
    } else {
      return null; // La etiqueta no fue encontrada
    }
  }

  const enableEditing = () => {
    editing.value = true;
    step2view.value.commentsWallHeadersBackup = [...step2view.value.commentsWallHeaders];
  }

  const savePreview = () => {
    let enunciado = `[BEGIN_ENUNCIADO]${tinyEditorPreview.value.editorInstance.getContent()}[END_ENUNCIADO]`;
    let genially =
      courseView.value.configPedagogical.show
        ? `[BEGIN_GENIALLY]<div style="width: 100%;"><iframe style="width: 100%;" frameborder="0" width="1200" height="675" allowfullscreen="allowfullscreen" src="${courseView.value.geniallyURL}"></iframe></div>[END_GENIALLY]`
        : '';
    let button = `[BEGIN_BOTON]<div style="font-family:'Open Sans',sans-serif; margin-top:12px;"><a href="" style="width:fit-content; padding:12px 40px; display:flex; align-items:center; justify-content:center; gap:4px; border-radius:30px; font-size:16px; font-weight:400; background-color:#009696; color:#fff; text-decoration:none;">Ir ${props.content.type == 'ATTACH' ? 'a la actividad' : 'al espacio de intercambio'}<i class="material-icons" style="font-size:16px;">arrow_forward</i></a></div>[END_BOTON]`;
    let newPreview = enunciado + genially + button;
    return newPreview;
  }

  const saveActivityView = () => {
    let enunciado = `[BEGIN_ENUNCIADO]${tinyEditorActivityView.value.editorInstance.getContent()}[END_ENUNCIADO]`;
    let genially =
      boardView.value.configPedagogical.show
        ? `[BEGIN_GENIALLY]<div style="width: 100%;"><iframe style="width: 100%;" frameborder="0" width="1200" height="675" allowfullscreen="allowfullscreen" src="${boardView.value.geniallyURL}"></iframe></div>[END_GENIALLY]`
        : '';
    let newActivityView =  genially + enunciado;
    return newActivityView;
  }

  const next = async () => {
    if (step.value == 1) {
      // Si esta en "Pantalla del curso" y falta agregar informacion en "Pantalla de la actividad", lo reenvia a esa vista
      // En caso contrario, lo envia a seleccionar los temas del CommentsWall
      if (stepSelected.value === 'course') {
        if (boardView.value.configPedagogical.show && v$.value.boardView.$invalid) {
          stepSelected.value = 'board'
          return
        }
        else {
          step.value = 2
        }
      }
      // Si esta en "Pantalla de la actividad" y falta agregar informacion en "Pantalla del curso", lo reenvia a esa vista
      // En caso contrario, lo envia a seleccionar los temas del CommentsWall
      if (stepSelected.value === 'board') {
        if (courseView.value.configPedagogical.show && v$.value.courseView.$invalid) {
          stepSelected.value = 'course'
          return
        }
        else {
          step.value = 2
        }
      }
    }      
    else {
      if(saving.value) return
      saving.value = true
      let model = {
        ...props.content,
        isMandatory: step2view.value.isMandatory,
        data: {
          Preview: savePreview(),
          Data: saveActivityView()
        },
        commentsWallHeaders: step2view.value.commentsWallHeaders
      }

      // compare commentsWallHeaders with commentsWallHeadersBackup to see if there were changes and if so, fill the newCommentsWallHeaders object with all of them to later do a for loop and update the commentsWallHeaders in separate requests
      let newCommentsWallHeaders = {}
      for (let i = 0; i < step2view.value.commentsWallHeaders.length; i++) {
        if (step2view.value.commentsWallHeaders[i] !== step2view.value.commentsWallHeadersBackup[i]) {
          newCommentsWallHeaders[i] = step2view.value.commentsWallHeaders[i]
        }
      }

      // if there are changes in the commentsWallHeaders, update them in for loop as separate requests to contentEditor_updateCommentsWallHeaders oldSubject: string, newSubject: string
      // if editing
      if (editing.value) {
        for (let i = 0; i < step2view.value.commentsWallHeaders.length; i++) {
          if (step2view.value.commentsWallHeaders[i] !== step2view.value.commentsWallHeadersBackup[i]) {
            try {
              await store.dispatch('contentEditor_updateCommentsWallHeaders', { headerChanges: { oldSubject: step2view.value.commentsWallHeadersBackup[i], newSubject: step2view.value.commentsWallHeaders[i] }, contentCfgId: props.content.id});
            } catch (error) {
              console.log(error)
              store.dispatch('notifications_create', { text: t('commentsWall.ERROR_EDITING_TOPIC', { number: i + 1 }) });
            }
          }
        }
      }
      

      try {
        model.id
          ? await store.dispatch('contentEditor_editContent', model)
          : await store.dispatch('contentEditor_createContent', model);
        emit('reload');
      } catch (error) {
        console.log(error)
        store.dispatch('notifications_create', { text: t('commentsWall.ERROR_SAVING_CONTENT') });
      } finally {
        saving.value = false;
      }

      console.log(model)
    }
  }

  const courseView = ref({
    enunciado: obtainContent('ENUNCIADO', props.content.data.Preview) || (props.content.id ? '' : enunciadoTemplate),
    geniallyURL: obtainGeniallyURL(obtainContent('GENIALLY', props.content.data.Preview)) || '',
    configPedagogical: {
      show: true,
      type: "genially",
      types: [
        { id: "genially", name: "Genially", },
      ]
    },
  })

  const boardView = ref({
    consigna: obtainContent('ENUNCIADO', props.content.data.Data) || (props.content.id ? '' : consignaTemplate),
    geniallyURL: obtainGeniallyURL(obtainContent('GENIALLY', props.content.data.Data)) || '',
    configPedagogical: {
      show: true,
      type: "genially",
      types: [
        { id: "genially", name: "Genially", },
      ]
    }
  })

  

  return {
    courseView,
    boardView,
    stepSelected,
    step,
    step2view,
    temas,
    themesQty,
    tinyEditorPreview,
    tinyEditorActivityView,
    saving,
    v$,
    editing,
    enableEditing,
    t,

    

    next,
    close
  }
},
validations() {
  return {
    courseView: {
      geniallyURL: {required, url}
    },
    boardView: {
      geniallyURL: {required, url}
    }
  }
}
}

</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';
@import './commonStyles.scss';

.disabled .dropdown {
  pointer-events: none;
}
.modal-activity{
  @include componentModal;
  display: flex;
  flex-direction: column;
  gap: 22px;
  padding: 38px;
  h4{
      padding-left: 4px;
  }
  .select-step{
      display: flex;
      align-items: center;
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
      span{
          font-size: 14px;
          font-weight: 600;
          padding: 12px 28px;
          text-align: center;
          cursor: pointer;
          &.--selected{
              color: $green;
              border-bottom: 3px solid $green;
          }
      }
  }
  .content-container{
      display: flex;
      flex-direction: column;
      gap: 22px;
  }
  .pedagogical{
      display: flex;
      justify-content: space-between;
  }

  .themes{
    display: flex;
    flex-direction: column;
    gap: 24px;
    font-weight: 600;
    font-size: 14px;
    width: 100%;
    .theme{
      display: flex;
      align-items: center;
      gap: 12px;
      width: 100%;
      input{
        border: none;
        outline: none;
        background-color: inherit;
        height: 30px;
        border-bottom: 1px dashed #D9D9D9;
        width: 100%;
        font-weight: 600;
        font-size: 14px;
      }
    }
  }
}

// editing mode, icon and text color
.config-title-edit {
display: flex;
align-items: center;
justify-content: space-between;
gap: 12px;
h4 {
  margin: 0;
}
.edit-button {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  font-weight: 500;
  background: #fff;
  color: $green;
  border-radius: 4px;
  cursor: pointer;
  i {
    font-size: 16px;
  }
  &.editing {
    opacity: 0.5;
    color: #000;
    pointer-events: none;

    i {
      color: #000;
    }
  }
}
}
</style>